import { BottomSheet } from 'app/design/primitives/bottom-sheet';
import { Text } from 'app/design/primitives/text';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { IconAlertTriangle, IconShare } from '@tabler/icons-react-native';
import { useTranslation } from 'react-i18next';
import { theme } from './theme';

export function ProfileActionsSheet({
  open,
  onClose,
  onShare,
  onReport,
  confirmReport,
}: {
  open: boolean;
  onClose: () => void;
  onShare: () => void;
  onReport?: () => void;
  confirmReport?: () => void;
}) {
  const { t } = useTranslation('neighbour-profile');
  const handleReport = confirmReport ?? onReport;
  return (
    <BottomSheet onClose={onClose} open={open} showIndicator>
      {!confirmReport ? (
        <BottomSheet.Action
          onPress={onShare}
          prefix={<IconShare strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['text.primary']} />}
        >
          {t('shareProfile')}
        </BottomSheet.Action>
      ) : null}
      {handleReport ? (
        <BottomSheet.Action
          onPress={handleReport}
          prefix={<IconAlertTriangle strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['surface.error.default']} />}
        >
          <Text color="surface.error.default">{t('reportUser')}</Text>
        </BottomSheet.Action>
      ) : null}
    </BottomSheet>
  );
}
